import React from 'react';
import classNames from 'classnames';

import { address } from '@store/FooterData';

import * as styles from './Address.module.scss';

export const Address: React.FC = () => {
	const { title, addressPL, addressAT, phonePL } = address;
	return (
		<div className={styles.flexSection}>
			<div className={styles.logo}></div>
			<address className="font-18">
				<p className={classNames(styles.orange, styles.contact, styles.thin)}>
					{title}
				</p>
				<p className={classNames(styles.orange, styles.address)}>{addressPL}</p>
				<p className={classNames(styles.orange, styles.tel)}>{phonePL}</p>
				<div className="mt-15">
					<p className={classNames(styles.orange, styles.address)}>
						{addressAT}
					</p>
				</div>
			</address>
		</div>
	);
};
